DeviceManager.Internal.SheetPrinter = {}